export function animatedLogo(animatedlogoType, animatedlogoTypeObject) {

    // export function animatedLogo(animatedlogotype) {

   console.log("animated logo animatedlogoType", animatedlogoType);
  console.log("animated logo animatedlogoTypeObject", animatedlogoTypeObject);

    // TOIDOD 

    /*
    // change scroll functions to intersection obvservers - started,  but need to look how to ensure we keep vars declatation to the correct objet
    its deof not atm, becuase instaead of obvject I'm using type to determine a dom element bad approach
  
    */
    //    $('#cc_logo');

    // const overviewArea = document.querySelector('#arc_logo');//test - replace the vars passed into here




    var type = animatedlogoType,
        // animatedlogo = $("#" + type + "_logo"), //animatedlogo,//$('#logo'),
        // animatedlogo = animatedlogoTypeObject,


        // animatedlogoheight = animatedlogoTypeObject.height(),
        overviewArea = animatedlogoTypeObject.closest('.animated-logo-area'),

        // overviewareaheight = $overviewarea.height(),
        // startanimatedlogo = $overviewarea.offset().top - 100, // value of top of logo area
        // finishanimatedlogo = (startanimatedlogo + (animatedlogoheight * 1)), // value of top of logo area
        // locked_animatedlogo_open = false, // this locks animation once open
        // locked_animatedlogo_close = false, // this locks animation once closed
        // animation_open = true, // this determines if the animation is open or not 

        animationtopmidstart = animatedlogoTypeObject.querySelector('.top_mid_face_start'),
        animationtopmidend = animatedlogoTypeObject.querySelector('.top_mid_face_end'),
        animationcolortopmidstart = animatedlogoTypeObject.querySelector('.color_top_mid_face_start'),
        animationcolortopmidend = animatedlogoTypeObject.querySelector('.color_top_mid_face_end'),
        //slanttmid:     
        animationslantmidstart = animatedlogoTypeObject.querySelector('.slant_mid_face_start'),
        animationslantmidend = animatedlogoTypeObject.querySelector('.slant_mid_face_end'),
        animationcolorslantmidstart = animatedlogoTypeObject.querySelector('.color_slant_mid_face_start'),
        animationcolorslantmidend = animatedlogoTypeObject.querySelector('.color_slant_mid_face_end'),
        //frontmid:    
        animationfrontmidstart = animatedlogoTypeObject.querySelector('.front_mid_face_start'),
        animationfrontmidend = animatedlogoTypeObject.querySelector('.front_mid_face_end'),
        animationcolorfrontmidstart = animatedlogoTypeObject.querySelector('.color_front_mid_face_start'),
        animationcolorfrontmidend = animatedlogoTypeObject.querySelector('.color_front_mid_face_end'),
        //bottommid:    
        animationbottommidstart = animatedlogoTypeObject.querySelector('.bottom_mid_face_start'),
        animationbottommidend = animatedlogoTypeObject.querySelector('.bottom_mid_face_end'),
        animationcolorbottommidstart = animatedlogoTypeObject.querySelector('.color_bottom_mid_face_start'),
        animationcolorbottommidend = animatedlogoTypeObject.querySelector('.color_bottom_mid_face_end'),
        //backmid:    
        animationbackmidstart = animatedlogoTypeObject.querySelector('.back_mid_face_start'),
        animationbackmidend = animatedlogoTypeObject.querySelector('.back_mid_face_end'),
        animationcolorbackmidstart = animatedlogoTypeObject.querySelector('.color_back_mid_face_start'),
        animationcolorbackmidend = animatedlogoTypeObject.querySelector('.color_back_mid_face_end'),
        //frontface: 
        animationfrontfacestart = animatedlogoTypeObject.querySelector('.front_face_start'),
        animationfrontfaceend = animatedlogoTypeObject.querySelector('.front_face_end'),
        animationcolorfrontfacestart = animatedlogoTypeObject.querySelector('.color_front_face_start'),
        animationcolorfrontfaceend = animatedlogoTypeObject.querySelector('.color_front_face_end'),
        //backface: 
        animationbackfacestart = animatedlogoTypeObject.querySelector('.back_face_start'),
        animationbackfaceend = animatedlogoTypeObject.querySelector('.back_face_end'),
        animationcolorbackfacestart = animatedlogoTypeObject.querySelector('.color_back_face_start'),
        animationcolorbackfaceend = animatedlogoTypeObject.querySelector('.color_back_face_end');

    if (type == "cc") {

        //      // if d maks exist - additional mask -
        var animationdmaskstart = animatedlogoTypeObject.querySelector('.d_mask_start'),
            animationdmaskend = animatedlogoTypeObject.querySelector('.d_mask_end'),
            animationcolordmaskstart = animatedlogoTypeObject.querySelector('.color_d_mask_start'),
            animationcolordmaskend = animatedlogoTypeObject.querySelector('.color_d_mask_end');

        //approach - review use of this    
        // var $items = $('#construction-clients-approach .service__item');


    } else if (type == "arc") {

        //approach - review use of this    

        // var $items = $('#architects-approach .service__item');

    } else if (type == "loader") {

        // var $items = "undefined";
    }

    // END variable declarations


    // console.log("type", type);
    // console.log("animatedlogo", animatedlogoTypeObject);
    // console.log("here");
    // console.log(" overviewArea", overviewArea);


    // 
    if (type == 'loader') {
        // console.log("if type == loader - open animation ")

        openanimation(type); //start the opening of the logo

    } else {
        animateLogos(overviewArea, type);

    }


    function closeanimation(type) {

        //  console.log('closenimation()');
        //    console.log("type", type);

        //  var $items = $('#architects-approach .approach-item'); // review thgis in line with other needs cc and loader
        // get rid of this? reivew al lthe other $items.each(function () { as well
        if (typeof $items !== 'undefined') {

            // console.log("$items.length")
            $items.each(function () {
                $(this).removeClass("active");
                // console.log('each item active class');
            });

        } // ($items.length){

        // --- START 

        //topmid:   
        animationtopmidstart.beginElement();
        animationcolortopmidstart.beginElement();
        //slanttmid:    
        animationslantmidstart.beginElement();
        animationcolorslantmidstart.beginElement();
        //frontmid:
        animationfrontmidstart.beginElement();
        animationcolorfrontmidstart.beginElement();
        //bottommid:    
        animationbottommidstart.beginElement();
        animationcolorbottommidstart.beginElement();
        //backmid: 
        animationbackmidstart.beginElement();
        animationcolorbackmidstart.beginElement();
        //frontface: 
        animationfrontfacestart.beginElement();
        animationcolorfrontfacestart.beginElement();
        //backface: 
        animationbackfacestart.beginElement();
        animationcolorbackfacestart.beginElement();

        if (type == 'cc') {
            // console.log("type == 'cc'", animationdmaskstart)
            //dmask: -- ensure to merge elment not always hgere
            animationdmaskstart.beginElement();
            animationcolordmaskstart.beginElement();
        }

        if (type == 'loader') {

            // console.log("loader animation now finished");
            setTimeout(function () {
                $('body').addClass("loader-animation-finished");
            }, 1000) // dur="500ms" - duration of animaton element
        }

    }; //closeanimation

    function openanimation(type) {

        //  console.log('openanimation()');
        // console.log("type", type);

        //  animatedlogoTypeObject.classList.add("active");
        // reivewthis each thing - not needed in many instances?
        // if ($items.length) {
        if (typeof $items !== 'undefined') {

            // console.log("$items.length")
            $items.each(function () {
                $(this).addClass("active");
                //   console.log('each item active class');
            });
        }



        // console.log('openanimation function');

        //topmid:       
        animationtopmidend.beginElement();
        animationcolortopmidend.beginElement();
        //slanttmid:      
        animationslantmidend.beginElement();
        animationcolorslantmidend.beginElement();
        //frontmid: 
        animationfrontmidend.beginElement();
        animationcolorfrontmidend.beginElement();
        //bottommid:    
        animationbottommidend.beginElement();
        animationcolorbottommidend.beginElement();
        //backmid: 
        animationbackmidend.beginElement();
        animationcolorbackmidend.beginElement();
        //frontface: 
        animationfrontfaceend.beginElement();
        animationcolorfrontfaceend.beginElement();
        //backface: 
        animationbackfaceend.beginElement();
        animationcolorbackfaceend.beginElement();

        if (type == 'cc') {

            //dmask:  -- ensure to merge elment not always hgere
            animationdmaskend.beginElement();
            animationcolordmaskend.beginElement();
        }


        if (type == 'loader') {

            // console.log("if type == loader close animatoin")

            setTimeout(function () {
                closeanimation(type); //start the closing of the logo
            }, 1000)

        }

    }; //closeanimation

    function animateLogos(overviewArea, type) {

        // review pluse itegrate accordingluy
        // console.log("ANImationg logo");
        // console.log("overviewArea", overviewArea);

        /* const options = {
             rootMargin: '0px 0px 25% 0px',
             // threshold: 0.5 // half of item height
         }*/
        // Multiple entries are passed into the callback. This is because if the browser is busy while
        // scrolling happens, multiple entries can accumulate between invocations of this callback.
        const intersectionCallback = (entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {

                    openanimation(type);
                    // console.log("openanimation(type);",type);
                    overviewArea.classList.add("--is-active");
                    //  console.log("LOGO Element is intersecting with the container ");
                } else {

                    closeanimation(type);
                    overviewArea.classList.remove("--is-active");
                    // console.log("closeanimation(type);",type);

                    //   console.log("LOGO Element is  NOT intersecting with the container ");
                }
            });

        };

        const intersectionObserverLogo = new IntersectionObserver(intersectionCallback, {
            rootMargin: '0px 0px -50% 0px',
            // threshold: 1 //0.5
            // root: overviewArea, // Leave this `root` out if you would like to use the device's viewport
        });

        intersectionObserverLogo.observe(overviewArea);

    }

} //export default function init()